module.exports = __webpack_public_path__ + "static/media/logo-admin.29f4c0ae.png";